import { CommonInputProps } from "@frui.ts/bootstrap/dist/controls/commonInputProps";
import { BindingProperty, bound, ensureObservableProperty, PropertyName, PropertyType } from "@frui.ts/helpers/dist";
import { BindingComponent, IBindingProps } from "@frui.ts/views";
import { get, isObservable, isObservableProp } from "mobx";
import { Observer } from "mobx-react-lite";
import * as React from "react";
import { Form, FormCheckProps } from "react-bootstrap";
import { setVisitedProperty } from "../utils/validationPatch";

export interface RadioArrayProps {
  option: any;
  isNumeric?: boolean;
  resetOnClick?: boolean;
  className?: string;
}

export class RadioArray<TTarget extends {} | Map<any, any>> extends BindingComponent<
  TTarget,
  RadioArrayProps & FormCheckProps & CommonInputProps & IBindingProps<TTarget>
> {
  protected get inheritedProps() {
    const { id, isInvalid, className, target, property, onValueChanged, isNumeric, resetOnClick, ...otherProps } = this.props;

    return otherProps;
  }

  render() {
    const { className, id } = this.props;
    const { target, property } = this.props as unknown as { target: TTarget; property: PropertyName<TTarget> };

    return (
      <Observer>
        {() => (
          <Form.Check
            {...this.inheritedProps}
            id={id}
            className={`radio-array ${className || ""}`}
            checked={this.value}
            type="radio"
            autoComplete="new-password"
            onBlur={() => setVisitedProperty(target, property)}
            onChange={this.handleValueChanged}
            onClick={this.handleClick}
          />
        )}
      </Observer>
    );
  }

  protected get value() {
    const { option, isNumeric, disabled } = this.props;

    const target = this.props.target as TTarget;
    const property = this.props.property as unknown as PropertyName<TTarget>;

    if (!target) {
      //// throw new Error("'target' prop has not been set");
      // tslint:disable-next-line: no-console
      return undefined;
    }
    if (!property) {
      throw new Error("'property' prop has not been set");
    }

    if (!isObservable(target) || !isObservableProp(target, property)) {
      ensureObservableProperty(target, property, target[property]);
    }

    if (option === undefined || option === null) {
      throw new Error("'option' prop is required for RadioArray!");
    }

    let value: string | number | undefined = option;

    if (isNumeric) {
      value = parseInt(option, 10);
    }

    if (disabled) {
      return false as PropertyType<TTarget, BindingProperty<TTarget>>;
    }

    return (get(target, property) === value) as PropertyType<TTarget, BindingProperty<TTarget>>;
  }

  @bound
  protected handleValueChanged(e: React.FormEvent<any>) {
    const { option, isNumeric, resetOnClick } = this.props;
    let value: undefined | string | number;
    if (isNumeric && option) {
      value = parseInt(option, 10);
    } else {
      value = option;
    }

    this.setValue(value);
  }
  @bound
  protected handleClick(e: React.FormEvent<any>) {
    const { option, resetOnClick } = this.props;
    const target = this.props.target as TTarget;
    const property = this.props.property as unknown as PropertyName<TTarget>;

    if (resetOnClick && get(target, property) === option && this.value) {
      this.setValue(undefined);
    }
  }
}
